export default "__VITE_ASSET__f57493c3__"